import type { BrandId } from './brand';
import { APP_BRAND } from './brand';
import {
  hidAiBlueIcon,
  hidAiConfirmIcon,
  hidTickBadgeIcon,
  hidAiIcon,
  hidDoorControllerIcon,
  hidDoorControllerUnclickedIcon,
  hidDoorControllerSelectedIcon,
  hidFloorIcon,
  hidLogo,
  hidStarIcon,
  hidVideoControllerIcon,
  hidVideoControllerSelectedIcon,
  hidVideoControllerUnclickedIcon,
  hidRecentConvIcon,
  hidFileUploadIcon,
} from '@/assets/brand/hid';

export type BrandConfig = {
  id: BrandId;
  productName: string;
  hidLogo?: string;
  hidAiIcon?: string;
  hidStarIcon?: string;
  hidAiBlueIcon?: string;
  hidAiConfirmIcon?: string;
  hidTickBadgeIcon?: string;
  hidFloorIcon?: string;
  hidDoorControllerIcon?: string;
  hidDoorControllerUnclickedIcon?: string;
  hidDoorControllerSelectedIcon?: string;
  hidVideoControllerIcon?: string;
  hidVideoControllerSelectedIcon?: string;
  hidVideoControllerUnclickedIcon?: string;
  hidRecentConvIcon?: string;
  hidFileUploadIcon?: string;
};

export const BRAND_CONFIG: Record<BrandId, BrandConfig> = {
  ag: {
    id: 'ag',
    productName: 'Agent Guard',
  },
  hid: {
    id: 'hid',
    productName: 'Agent Guard',
    hidLogo,
    hidAiIcon,
    hidStarIcon,
    hidAiBlueIcon,
    hidAiConfirmIcon,
    hidTickBadgeIcon,
    hidFloorIcon,
    hidDoorControllerIcon,
    hidDoorControllerUnclickedIcon,
    hidDoorControllerSelectedIcon,
    hidVideoControllerIcon,
    hidVideoControllerSelectedIcon,
    hidVideoControllerUnclickedIcon,
    hidRecentConvIcon,
    hidFileUploadIcon,
  },
};

export function getBrandConfig(brand: BrandId = APP_BRAND): BrandConfig {
  return BRAND_CONFIG[brand];
}
